var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrp"},[_c('section',[_c('p',{staticClass:"success-icon"},[_c('van-icon',{attrs:{"color":"#F65F5F","size":"81px","name":"warning"}})],1),_c('p',{staticClass:"success-text"},[_vm._v("开票二维码已失效")]),_c('p',{staticClass:"res-tit"},[_vm._v("请联系商家咨询")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }